import { useEffect } from "react";
import { useScrollStore } from "@/common/store/scrollStore";

export const useBodyLock = (flag: boolean) => {
  const scrollElement = useScrollStore((state) => state.scrollElement);

  useEffect(() => {
    if (!scrollElement) {
      // ignore, happens during page close
    } else if (flag) {
      scrollElement.classList.add("noScroll");
    } else {
      scrollElement.classList.remove("noScroll");
    }

    return () => scrollElement?.classList.remove("noScroll");
  }, [flag, scrollElement]);
};

